import React from 'react';
import ReactDOM from 'react-dom/client';
import './scripts/nav-toggle.js';
